import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/download.svg';

import styles from './DownloadIcon.styles';

type ArrowUpIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'DownloadIcon' });

export default function DownloadIcon({ className }: ArrowUpIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
